import { Button } from 'react-bootstrap';
import IpUtil from '../../util/Ip';
import IpStore from '../../stores/IpStore';
import Loading from '../Loading';
import React from 'react';

class Ip extends React.Component {
    constructor(props) {
        super(props);

        //this.state = Ip.getState(props);
    }

    //static getState (props) {
    //    return {
    //        reverse: IpStore.getPtr(props.ip),
    //        reverseLoading: IpStore.ptrLoading(props.ip)
    //    };
    //}
    //
    //componentDidMount = () => {
    //    IpStore.addChangeListener(this._change);
    //}
    //
    //componentWillUnmount = () => {
    //    IpStore.removeChangeListener(this._change);
    //}

    render () {
        const { ip, ...props } = this.props;
        // const { reverse, reverseLoading } = this.state;

        return <div className="ip">
            <div>{IpUtil.format(ip)} {/*reverseLoading && <Loading message="" />*/}</div>
            {/*reverse && <div className="low small text-nowrap">{IpUtil.formatHostname(reverse)}</div>*/}
        </div>;
    }

    _change = () => {
        this.setState(Ip.getState(this.props));
    }
}
Ip.propTypes = {
    ip: React.PropTypes.string.isRequired
};

export default Ip;



// WEBPACK FOOTER //
// ./app/components/Ip/Ip.js